<svg id="Offers-read-more" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g id="_1920-2" data-name="1920-2" transform="translate(0 0)">
    <g id="Group-6">
      <path id="Combined-Shape" d="M8.485,0a.97.97,0,0,1,.97.97V7.515H16a.97.97,0,1,1,0,1.939H9.454V16a.97.97,0,0,1-1.94,0V9.454H.97a.97.97,0,1,1,0-1.939H7.515V.97A.97.97,0,0,1,8.485,0Z" transform="translate(12 0) rotate(45)" fill="#44454d" fill-rule="evenodd"/>
    </g>
  </g>
</svg>
